module.exports = __webpack_public_path__ + "static/media/Portrait-10053.71928d9e.jpg";